import { rem } from 'polished'
import styled from 'styled-components'

export const AuditLogRecordLabelStyled = styled.div`
  padding: 0 ${rem(16)};
  text-transform: uppercase;
  border-radius: 0 ${rem(16)} ${rem(16)} 0;
  font-weight: ${(props) => props.theme.fontWeights.bold};
  font-size: ${(props) => props.theme.fontSizes.body2};
`
